import {
  AbstractControl,
  FormArray,
  FormGroup,
  FormRecord,
} from '@angular/forms';

export const inDepth = <T>(
  control: AbstractControl<T>,
  callback: (control: AbstractControl<T>) => void,
): void => {
  callback(control);

  if (control instanceof FormGroup || control instanceof FormRecord) {
    Object.values(control.controls).forEach((childControl) => {
      inDepth(childControl, callback);
    });
  }

  if (control instanceof FormArray) {
    control.controls.forEach((childControl) => {
      inDepth(childControl, callback);
    });
  }
};
